import styled from "@emotion/styled";

import { fontSourceSerif4, theme } from "shared/lib/styles";

import { AdSlot } from "scmp-app/components/advertisement/ad-slots/ad-slot";
import { AppFooter } from "scmp-app/components/app-footer";
import { Loading } from "scmp-app/components/common/loading";
import { ContentItemLivePrimary } from "scmp-app/components/content/content-item-render/variants/live-primary";

export const StyledContentItemLivePrimary = styled(ContentItemLivePrimary)``;

export const StyledLoading = styled(Loading)`
  margin-block: 48px;
`;

export const StyledAppFooter = styled(AppFooter)`
  margin-block-start: 48px;
`;

export const StyledAdSlot = styled(AdSlot)`
  inline-size: auto;
  margin-block: 12px;
  margin-inline: auto;

  ${theme.breakpoints.up("desktop")} {
    margin-block: 0;
  }
`;

export const Heading = styled.div`
  margin-block-end: 24px;
  padding-block: 20px;

  color: #000000;
  font-weight: 400;
  font-size: 32px;
  font-family: ${fontSourceSerif4};
  font-style: normal;
  line-height: 90%;
  letter-spacing: -1.28px;
  text-align: center;
  text-transform: uppercase;
  font-feature-settings:
    "clig" off,
    "liga" off;
  border-block-end: 1px #000000 solid;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 32px 24px;

    font-size: 48px;
    letter-spacing: -1.92px;
  }

  ${theme.breakpoints.up("desktop")} {
    font-size: 64px;
    letter-spacing: -2.56px;
  }
`;

export const AdContainer = styled.div`
  display: flex;
`;

export const Container = styled.div`
  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 712px;
    margin-inline: auto;
  }

  ${StyledContentItemLivePrimary}:not(:last-child), ${AdContainer}:not(:last-child) {
    margin-block-end: 20px;
    padding-block-end: 20px;
    border-block-end: 1px rgba(0, 0, 0, 0.2) solid;

    ${theme.breakpoints.up("tablet")} {
      margin-block-end: 24px;
      padding-block-end: 24px;
    }
  }
`;

export const Newsletter = styled.div`
  display: grid;
  align-items: center;
  /** set min height to prevent CLS */
  min-block-size: 310px;
  margin-block: 20px;

  ${theme.breakpoints.up("tablet")} {
    /** set min height to prevent CLS */
    min-block-size: 230px;
    margin-block: 32px;
  }
`;
